import { render } from "./Router.vue?vue&type=template&id=780f72cc&scoped=true"
import script from "./Router.vue?vue&type=script&lang=js"
export * from "./Router.vue?vue&type=script&lang=js"

import "./Router.vue?vue&type=style&index=0&id=780f72cc&scoped=true&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780f72cc"]])

export default __exports__